import { Customer } from "../../../types/customer";

export const validateCustomerForm = (customer: Customer): string[] => {
    const requiredFields = [
        { field: "account_holder_name", label: "Account Holder" },
        { field: "iban", label: "IBAN" },
        { field: "bic", label: "BIC" },
        { field: "email", label: "Primary Email" },
        { field: "phone", label: "Phone" },

        { field: "address.recipient_name", label: "Recipient Name" },
        { field: "address.street_address", label: "Street Address" },
        { field: "address.postal_code", label: "Postal Code" },
        { field: "address.city", label: "City" },
    ];

    const missingFields = requiredFields
        .filter(({ field }) => {
            const keys = field.split(".");
            let value: any = customer;
            for (const key of keys) {
                if (value) {
                    value = value[key];
                }
            }
            return !value;
        })
        .map(({ label }) => label);

    return missingFields;
};
